<template>
  <div class="contractManagement-examine-bd">
    <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="500px">
      <div class="dialog-body">
        <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
          <el-row>
            <el-form-item :label="$t('device_detail_openCard_changeUser.chi_ka_ren')" prop="cardOwner">
              <el-input v-model="form.cardOwner"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="$t('device_detail_openCard_changeUser.chi_ka_ren_dian_hua')" prop="cardOwnerPhone">
              <el-input v-model="form.cardOwnerPhone"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="warning" @click="saveContact">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  props: ['value'],
  data() {
    return {
      visible: false,
      form: {
        cardOwner: '',
        cardOwnerPhone: '',
        deviceCardId: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        cardOwner: [{ required: true, message: this.$t('device_detail_openCard_changeUser.chi_ka_ren_bi_tian') }]
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form.deviceCardId = this.model.data.deviceCardId;
      this.form.cardOwner = this.model.data.cardOwner;
      // this.form.cardOwnerPhone = this.model.data.cardOwnerPhone;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveContact: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // bootCardChangeUserPwd
        if (this.model.type === 'password') {
          this.$postJSON(apis.bootCardChangeUserPwd, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_modify_success'),
              type: 'success',
            });
            this.closeDialog();
            this.$emit('success');
          });
        } else {
          this.$postJSON(apis.bootCardChangeUser, this.form).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });
              this.closeDialog();
              this.$emit('success');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
